import React, { useState } from "react";
import foto from "../images/multitessere_card_small.png";
import { useNavigate } from "react-router-dom";
import "../styles/CardMultitessere.css";

function CardMultitessere() {
    const [isHovered, setIsHovered] = useState(false);
    const navigate = useNavigate();

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    return (
        <div
            className="card-multitessere d-flex flex-row align-self-center"
            onClick={() => navigate("/multitessere")}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{
                marginTop: "1em",
                transition: "transform 0.5s" // Aggiunta di una transizione per un effetto più fluido
            }}
        >
            <img
                src={foto}
                alt="Immagine"
                style={{
                    width: "100%",
                    border: "solid",
                    borderRadius: "1em",
                    overflow: "hidden",
                    transform: isHovered ? "scale(1.15)" : "scale(1)" // Modifica della scala al passaggio del mouse
                }}
            />
            <div className="card-multitessere-text"></div>
        </div>
    );
}

export default CardMultitessere;
